import { Button } from "@/components/ui/button"
import { Tagline } from "@/components/pro-blocks/landing-page/tagline"

export function FinalCTA() {
  return (
    <section className="bg-secondary section-padding-y">
      <div className="container-padding-x container mx-auto">
        <div className="mx-auto flex max-w-2xl flex-col items-center gap-6 text-center">
          <Tagline>Начните сегодня</Tagline>
          <h2 className="heading-lg text-foreground">Хватит тонуть в обращениях</h2>
          <p className="text-muted-foreground text-lg">
            Подключитесь за 5 минут и увидите полную картину того, что волнует ваших клиентов. Бесплатно на 14 дней.
          </p>
          <Button size="lg" className="mt-2">
            Начать бесплатно
          </Button>
          <p className="text-muted-foreground text-sm">
            Подключение за 5 минут • Карта не требуется • Отмена в любой момент
          </p>
        </div>
      </div>
    </section>
  )
}
